var MDB = window.MDB || {};;
MDB.Users = MDB.Users || {};

(function ($) {
    $.extend(MDB.Users, {
        _crudBaseUrl: '/api/Users/',
        
        _toggleUserEnabled: function(id, enabled){
            var promptText = enabled ? MDB.loadResourceString('Users_Index_EnableUserPrompt') : MDB.loadResourceString('Users_Index_DisableUserPrompt');

            var deferred = $.Deferred(function () {
                MDB.prompt(undefined, promptText, function (res) {
                    if (!res){
                        return;
                    }

                    $.ajax({
                        url: MDB.Users._crudBaseUrl + id + '?isEnabled=' + enabled,
                        method: 'PUT',
                        contentType: 'application/json',
                        success: function(){
                            deferred.resolve();
                        },
                        error: function (data) {
                            deferred.reject();
                            
                            if (data.responseJSON) {
                                MDB.alert(data.responseJSON.Message);
                            }
                        }
                    });
                })
            });
            
            return deferred.promise();
        },
        
        
        bootUsers: function(tableSelector, opts){
            var currentUserId = MDB.CurrentUser.Id;
            opts = $.extend({
                canToggleAccounts: false,
                editLinkTemplate: ''
            }, opts);
            
            
            MDB.initializeAjaxDataTable(tableSelector, {
                endpoint: MDB.Users._crudBaseUrl + 'DataTables',
                columnRenderers: {
                    'EditLink': function (_, mode, data) {
                        var userId = data['Id'];
                        var isEnabled = data['IsEnabled'];
                        
                        var canToggle = opts.canToggleAccounts && userId !== currentUserId;
                         
                        var toggleUserControl = ''
                            , editUserControl = '';
                        
                        if (canToggle){
                            toggleUserControl = [
                                sprintf('<button class="btn btn-primary btn-xs toggle-enabled mr-3" data-enabled="%s" data-toggle="tooltip" data-title="%s" data-id="%s">', isEnabled, MDB.loadResourceString('Users_Index_ToggleEnabled_Tooltip'), userId),
                                sprintf('<i class="fa fa-%scircle-o"></i>', isEnabled ? 'check-' : ''),
                                '</button>'
                            ].join('');  
                        }

                        if (opts.editLinkTemplate){
                            editUserControl = [
                                sprintf('<a href="%s" class="btn btn-primary btn-xs" data-toggle="tooltip" data-title="%s">', opts.editLinkTemplate + '&id=' + userId, MDB.loadResourceString('Users_Index_EditAccount_Tooltip')),
                                '<i class="fa fa-edit"></i>',
                                '</a>'
                            ].join('');
                        }

                        return [
                            '<div class="box-tools pull-right">',
                            toggleUserControl,
                            editUserControl,
                            '</div>'].join('');
                    }
                }
            });


            $(tableSelector).on('click', '.toggle-enabled', function (e) {
                var $target = $(e.currentTarget);
                var isEnabled = !$target.data('enabled');
                var userId =$target.data('id');
                
                MDB.Users._toggleUserEnabled(userId, isEnabled)
                    .done(function () {
                        var icon = $target.children('i');

                        $target.data('enabled', isEnabled);

                        icon.attr('class', '');
                        icon.addClass('fa ' + (isEnabled ? 'fa-check-circle-o' : 'fa-circle-o'));
                    });
            });
        }
    });
    
    $.extend(MDB, {
        initUsersGrid: function (table, divisionId, forArea, canDisable, currentUserId) {
            var builder = MDB.KendoConfigBuilder;
            var crudBaseUrl = '/api/Users/KendoGrid';
            var autocompleteUrl = crudBaseUrl + 'Suggestions' + (forArea ? '?divisionId=' + divisionId : '');
            var createLinkHref = table.data('create-url');
            var editLinkHref = table.data('edit-url');
            var returnUrl = table.data('return-url');
            var dateFormat = 'dd-MM-yyyy HH:mm';
            var pageSize = 100;

            var dataSource = {
                transport: {
                    read: builder.dataSourceHybridClientServerRead(table, {
                        url: crudBaseUrl,
                        data: {
                            membersToExpand: [ 'DivisionName', 'RoleNames' ],
                            divisionId: forArea ? divisionId : null
                        }
                    })
                },
                schema: {
                    model: {
                        Id: 'Id',
                        fields: {
                            LastLogin: { type: 'date' },
                            IsEnabled: { type: 'boolean' }
                        }
                    },
                    data: 'Data',
                    total: 'Total'
                },
                sort: {
                    field: 'FullName',
                    dir: 'asc'
                },
                pageSize: pageSize,
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                requestEnd: builder.dataSourceOffsetUTFDatesToLocalTime()
            };

            var gridConfig = {
                dataSource: dataSource,
                toolbar: builder.gridToolbarCustomCommandTemplate(
                    'create-custom',
                    createLinkHref + '?divisionId=' + divisionId,
                    null,
                    { returnUrl: returnUrl },
                    'Area_Index_CreateAccount_Button'),
                columnMenu: true,
                columns: [
                    {
                        field: 'FullName',
                        title: MDB.loadResourceString('Users_Index_Users_Name_Header'),
                        filterable: builder.gridStringFilter(autocompleteUrl, 'FullName')
                    },
                    {
                        field: 'LoginName',
                        title: MDB.loadResourceString('Users_Index_Users_Username_Header'),
                        filterable: builder.gridStringFilter(autocompleteUrl, 'LoginName')
                    },
                    {
                        field: 'Email',
                        title: MDB.loadResourceString('Users_Index_Users_Email_Header'),
                        filterable: builder.gridStringFilter(autocompleteUrl, 'Email')
                    },
                    {
                        field: 'LastLogin',
                        title: MDB.loadResourceString('Users_Index_Users_LastLogin_Header'),
                        format: sprintf('{0:%s}', dateFormat),
                        filterable: builder.gridDateTimeFilter(dateFormat)
                    },
                    {
                        field: 'RolesNamesStr',
                        title: MDB.loadResourceString('Users_Index_Users_Roles_Header'),
                        filterable: builder.gridStringFilter(autocompleteUrl, 'RolesNamesStr'),
                        sortable: false
                    },
                    builder.gridCommandColumn([
                        builder.gridCustomLinkCommand('edit-custom', editLinkHref, ['Id'], { returnUrl: returnUrl })
                    ])
                ],
                filterable: builder.gridGlobalFilterableSettings(),
                sortable: {
                    mode: 'multiple'
                },
                resizable: true,
                reorderable: true,
                pageable: _.merge(builder.gridPageableForVirtualScrollSettings(), builder.gridPageableSettings()),
                scrollable: false
            };

            if (!forArea) {
                gridConfig.columns.splice(4, 0, {
                    field: 'DivisionName',
                    title: MDB.loadResourceString('Users_Index_Users_DivisionName_Header'),
                    filterable: builder.gridStringFilter(autocompleteUrl, 'DivisionName')
                });

                gridConfig.columns.splice(6, 0, {
                    field: 'IsEnabled',
                    title: MDB.loadResourceString('Users_Index_Users_IsEnabled_Header'),
                    template: builder.gridCheckboxTemplate('IsEnabled', 'chkbx', !canDisable, currentUserId),
                    filterable: builder.boolDropdownFilter()
                });

                gridConfig.columnMenuInit = builder.gridColumnMenuRemoveFilterFor('IsEnabled', 1);
            }

            var grid = table.kendoGrid(gridConfig).data('kendoGrid');

            table.on('change', 'input.chkbx', function (e) {
                var self = $(this);
                var dataItem = grid.dataItem($(e.target).closest('tr'));
                var checked = this.checked;
                
                MDB.Users._toggleUserEnabled(dataItem.get('Id'), checked)
                    .done(function () {
                        dataItem.IsEnabled = checked; 
                    })
                    .fail(function () {
                        self.prop('checked', !checked); 
                    });
            });
        }
    });
})(jQuery);